// import sha256 from 'crypto-js/sha256'
// import dayjs from 'dayjs'
import { useEffect, useMemo } from 'react'
import { Helmet } from 'react-helmet'

import { COUNTRY, countryIncludes, IS_COUNTRY } from '../../constants/countries'
// import { api } from '../../utils/api-client'

const METADATA = {
  '/': {
    // home
    title: COUNTRY.meta.title,
    desc: COUNTRY.meta.description,
    keywords: '',
  },
  '/promotions': {
    title: 'Bonificación, Reembolso en Juegos de Casino | Fun88',
    desc: 'Duplicamos tu 1er depósito hasta $5,000 Pesos y hasta $11,000 Pesos de bono de bienvenida. Refiere a tus amigos y gana comisión. Con MexPlay ganas más.',
    keywords: '',
  },
  '/sports': {
    title: 'Juega deportes en vivo ilimitados en línea | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY.name}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  '/help/terminos-y-condiciones': {
    title: 'Lee los Términos y Condiciones | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY.name}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  '/help/withdraw': {
    title: `El Casino Mas Serio de ${COUNTRY.name}, tu retiro en menos de 20 minutos`,
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY.name}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  '/help/we': {
    title: 'Mejores Juegos en Línea y de Casino | Sobre Nosotros Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY.name}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  '/sports/bti': {
    title: 'Juega y Apuesta en Juegos de Casino en Vivo | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY.name}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  '/help/betting-conditions': {
    title:
      'Condiciones de Apuesta, Apuesta y Juega en el Casino en Línea | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY.name}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  '/help/affiliate-program': {
    title: 'Programa de Afiliados para Juegos de Casino en Línea | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY.name}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  '/contact-us': {
    title: 'Juega y Apuesta en Casino en Vivo | Contáctanos Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY.name}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  '/sports/im': {
    title: 'Juega juegos de mensajería instantánea en vivo | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY.name}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  '/help/privacy-notice-and-site-cookies': {
    title: 'Juegos de Casino en Línea | Política de Privacidad de Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY.name}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  '/help/juego-responsable': {
    title: 'Reglas y Regulaciones para Deportes en Línea | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY.name}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  '/help/refund-policy': {
    title: 'Política de Reembolso para Deportes en Línea | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY.name}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  '/help/faq': {
    title: 'Preguntas Frecuentes para Casino en Línea y Apuestas | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY.name}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  '/help/deposit': {
    title: 'Apuesta y Juega en el Casino en Línea | Opciones de Depósito Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY.name}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  '/help/betting-mechanics': {
    title: 'Reglas de Apuestas para Jugar en el Casino en Línea | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY.name}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
}

type MetaDataKey = keyof typeof METADATA

const WebTitle = () => {
  const currentPage = window.location.pathname as MetaDataKey
  // const email = useBoundStore(state => state.user.email)
  // const phone = useBoundStore(state => state.user.phone)
  // const userId = useBoundStore(state => state.user.userID)
  // const birthday = useBoundStore(state => state.user.birthday)
  // const firstName = useBoundStore(state => state.user.first_name)
  // const lastName = useBoundStore(state => state.user.last_name)

  useEffect(() => {
    // api.fbGraph({
    //   data: [
    //     {
    //       action_source: 'website',
    //       event_id: 12340,
    //       event_name: 'ViewContent',
    //       event_time: dayjs().unix(),
    //       user_data: {
    //         em: [email ? sha256(email).toString() : null],
    //         ph: [phone ? sha256(phone).toString() : null],
    //         client_user_agent: navigator.userAgent,
    //         external_id: [userId ? sha256(userId).toString() : null],
    //         db: [birthday ? sha256(birthday).toString() : null],
    //         fn: [firstName ? sha256(firstName).toString() : null],
    //         ln: [lastName ? sha256(lastName).toString() : null],
    //       },
    //       custom_data: {
    //         page,
    //       },
    //     },
    //   ],
    // })

  }, [])

  const isNoIndexDomain = useMemo(() => {
    if (window.location.pathname.includes('/profile')) return true
    if (!countryIncludes(['AR', 'PY'])) return false
    if (IS_COUNTRY.AR && !window.location.hostname.includes('fun88ar.com'))
      return true
    if (IS_COUNTRY.PY && !window.location.hostname.includes('fun88py.com'))
      return true
    return false
  }, [])

  const metaData = useMemo(() => {
    return METADATA[currentPage] ?? METADATA['/']
  }, [currentPage])

  return (
    <Helmet>
      <title>{metaData.title}</title>
      {metaData.desc && <meta name="description" content={metaData.desc} />}
      {metaData.keywords && (
        <meta name="keywords" content={metaData.keywords} />
      )}
      {isNoIndexDomain ? (
        <meta name="robots" content="noindex" />
      ) : (
        <meta name="robots" content="dofollow, index" />
      )}
    </Helmet>
  )
}

export default WebTitle
